export const navigationData = [
  {
    id: 1,
    name: 'Inicio',
    href: '/',
  },
  {
    id: 2,
    name: 'Nosotros',
    href:'/nosotros'
  },
  {
    id: 3,
    name: 'Propiedades',
    href:'/propiedades',

  },
  {
    id: 4,
    name: 'Servicios',
    href:'/servicios'
  },
  {
    id: 5,
    name: 'Contacto',
    href:'/contacto'
  },
  {
    id: 6,
    name: 'Publica gratis',
    href:'https://demo-landing-1.unne.cl/'
  },
  {
    id: 7,
    name: 'Intranet',
    href: 'https://unne.prop360.cl/',
  },
];
